import { render, staticRenderFns } from "./SwitchGreenSelected.vue?vue&type=template&id=3a79c11d"
import script from "./SwitchGreenSelected.vue?vue&type=script&lang=js"
export * from "./SwitchGreenSelected.vue?vue&type=script&lang=js"
import style0 from "./SwitchGreenSelected.vue?vue&type=style&index=0&id=3a79c11d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports